import styled from 'styled-components';
import breakpointsMinWidth from '@styling/breakpointsMinWidth';
import { white, PrimaryDark } from '../../../../../styling/theme';

export const ButtonWrapper = styled.div`
  cursor: pointer;
  color: #333d47;
  font-size: 12px;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
export const TextSpan = styled.span`
  padding: 4px 6px;
  border-radius: 4px;
  display: block;
  &:hover {
    background: rgba(162, 162, 162, 0.13);
  }
`;
export const Sup = styled.sup`
  display: flex;
  align-items: center;
  height: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  border-radius: 2px;
  margin-left: 4px;
  padding: 0 3px;
  background: ${white};
  color: ${PrimaryDark};
  line-height: unset;
`;
